import * as d3 from "d3";

const URL_UNSAFE_CHARS_REGEX = /[^A-Za-z0-9-_.~]/g;

/**
 * Converts a given string to a name can be safely appended to URL.
 * That conversion is destructive and not reversible, it doesn't preserve
 * exactly value of the string, just useful for adding some human-readable
 * data to URL.
 */
export function toUrlSafeName(name: string): string {
    return (name || "").replace(URL_UNSAFE_CHARS_REGEX, "_");
}

export const formatNumberImpl = d3.format("-,.2d");

export function formatNumber(num: string | number): string {
    const val = typeof num === "number" ? num : parseFloat(num);
    return formatNumberImpl(val);
}

export function parseUrlForFileName(url: string): string {
    const reg = /[a-zA-z0-9-_]+.(png|svg|jpg|gif)/g;
    const fileNameMass = url.match(reg);
    return fileNameMass ? fileNameMass.join("\n") : url;
}
